import { RouteRecordRaw } from 'vue-router';

const _prefix = "fnx";

const corePageRoutes: RouteRecordRaw[] = [
    {
        path: "/legalentity",
        name: "LegalEntity",
        component: () => import("@/components/core/features/LegalEntity/LegalEntityComponent.vue"),
        meta: { requiresAuth: true,
            titleTrail: ['core', 'legalEntity'],
        },
    },
    {
        path: "/sourcesysteminstance",
        name: "SourceSystemInstance",
        component: () => import("@/components/core/features/SourceSystemInstance/SourceSystemInstanceComponent.vue"),
        meta: { requiresAuth: true,
            titleTrail: ['core', 'sourceSystemInstance'],
         },
    }
];

export default corePageRoutes;